import React, { useState, useEffect } from 'react';
import DropdownNoImage from '../../../../Components/DropDown/DropdownNoImage';
import PrimaryButton from '../../../../Components/Buttons/PrimaryButton';
import { useGlobalContext } from '../../../../Context/GlobalContext';
import styles from './TopHeader.module.css';

const TopHeader = ({ onAddStaffClick, onOutletChange }) => {
    const {
        outletOptions,
        setOutletOptions,
        userAssignedOutlets,
        selectedOutlet,
        setSelectedOutlet,
        loggedOutletID,
        setOutletAccessMap,
    } = useGlobalContext();

    const [towerOptions, setTowerOptions] = useState([]);

    // Initialize tower options from user assigned outlets (only edit permission)
    useEffect(() => {
        if (userAssignedOutlets?.length) {
            // Filter to only show outlets with edit permission
            const editOutlets = userAssignedOutlets.filter((outlet) => outlet.mode === "edit");
            
            const mapped = editOutlets.map((outlet) => ({
                label: (
                    <span className={styles.outletText}>
                        {outlet.name}
                        {outlet.mode === "edit" && " (Edit)"}
                    </span>
                ),
                value: outlet.id,
                data: outlet,
            }));

            setTowerOptions(mapped);
            
            // Check if current selected outlet has edit permission
            const currentOutletHasEdit = editOutlets.some((o) => o.id === selectedOutlet);
            
            // If no outlet selected OR current outlet doesn't have edit permission, set default
            if (!selectedOutlet || !currentOutletHasEdit) {
                // Prefer loggedOutletID if it has edit permission, otherwise use first edit outlet
                const loggedOutletHasEdit = editOutlets.some((o) => o.id === loggedOutletID);
                if (loggedOutletHasEdit) {
                    setSelectedOutlet(loggedOutletID);
                } else if (editOutlets.length > 0) {
                    setSelectedOutlet(editOutlets[0].id);
                }
            }

            const accessMap = {};
            userAssignedOutlets.forEach((o) => {
                accessMap[o.id] = o.mode; // "edit" or "view"
            });
            setOutletAccessMap(accessMap);
        }
    }, [userAssignedOutlets, loggedOutletID, setOutletAccessMap, setSelectedOutlet, selectedOutlet]);

    const handleTowerSelect = (selectedOption) => {
        const newOutletId = selectedOption?.value;
        
        // Only update if the selected outlet is different from current
        if (newOutletId !== selectedOutlet) {
            setSelectedOutlet(newOutletId);
            // Notify parent component that outlet has changed
            if (onOutletChange) {
                onOutletChange();
            }
        }
    };

    const handleAddStaffMember = () => {
        if (onAddStaffClick) {
            onAddStaffClick();
        }
    };

    return (
        <div className={styles.topHeader}>
            <div className={styles.topHeaderContent}>
                <div className={styles.leftSection}>
                    <DropdownNoImage
                        options={towerOptions}
                        selectedLabel={
                            towerOptions.find(
                                (tower) => tower.value === selectedOutlet
                            )?.label || ""
                        }
                        onSelect={handleTowerSelect}
                        dropdownClass={`${styles.towerDropdown} headerOutletFilter topHeaderDropdown`}
                        dropdownMenuClass={`${styles.towerDropdownMenu} outletFilterList`}
                        placeholder="List Towers"
                        placeholderClass={styles.placeholder}
                        labelText=""
                    />
                </div>
                
                <div className={styles.rightSection}>
                    <PrimaryButton
                        text="Add Therapist"
                        onClick={handleAddStaffMember}
                        className={styles.addStaffButton}
                    />
                </div>
            </div>
        </div>
    );
};

export default TopHeader;
